import { render, staticRenderFns } from "./GDQQuestionnaire.vue?vue&type=template&id=2564e40c"
import script from "./GDQQuestionnaire.vue?vue&type=script&lang=js"
export * from "./GDQQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./GDQQuestionnaire.vue?vue&type=style&index=0&id=2564e40c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports